import { z } from "zod"

export const AgencyUserSchema = z.object({
  id: z.number(),
  username: z.string(),
  first_name: z.string(),
  last_name: z.string().nullable(),
  full_name: z.string(),
  email: z.string(),
  status: z.number(),
  agency_id: z.number(),
  agency_name: z.string().nullable(),
  avatar: z.string().nullable(),
  two_fa_type: z.string().nullable(),
  failed_2fa_attempts: z.number(),
  last_login_at: z.string().nullable(),
  last_login_ip: z.string().nullable(),
  last_login_user_agent: z.string().nullable(),
  last_login_browser: z.string().nullable(),
  last_login_os: z.string().nullable(),
  last_login_attempt_at: z.string().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
})

export const AgencyUserFormSchema = z.object({
  username: z.string().min(2, "agencyUsers.validation.usernameRequired"),
  first_name: z.string().min(1, "agencyUsers.validation.firstNameRequired"),
  last_name: z.string().min(1, "agencyUsers.validation.lastNameRequired"),
  email: z.string().email("agencyUsers.validation.emailInvalid"),
  password: z
    .string()
    .min(6, "agencyUsers.validation.passwordMin")
    .optional()
    .default(""),
})

export const IntegrationSchema = z.object({
  id: z.number(),
  user_id: z.number(),
  type: z.number(),
  type_name: z.string(),
  user: z.string(),
  pass: z.string(),
  pass1: z.string().nullable(),
  enabled: z.boolean(),
  created_at: z.string().nullable(),
  can_edit: z.boolean(),
})

export const CopyableIntegrationSchema = z.object({
  type: z.number(),
  name: z.string(),
})

export const ResetPasswordSchema = z.object({
  password: z.string().min(6, "agencyUsers.validation.passwordMin"),
})

export const IntegrationTypeMap: Record<number, string> = {
  1: "Ivolfy",
  2: "Moodle",
  3: "Viewtravel",
  4: "Inside",
  5: "ActiveX",
  6: "Bestravel Admin",
  9: "Llego Travelgea Ticketing",
  10: "Orbis",
  11: "Own Offers",
  12: "E-Sim Breeze",
  13: "Hotel Comparator",
  14: "Bene System",
}

export const STATUS_ACTIVE = 10
export const STATUS_SUSPENDED = 2
export const STATUS_DELETED = 0

export const STATUS_MAP: Record<
  number,
  { label: string; color: string; icon: string; description: string }
> = {
  [STATUS_ACTIVE]: {
    label: "active",
    color: "green",
    icon: "fa fa-check-circle",
    description: "accountActive",
  },
  [STATUS_SUSPENDED]: {
    label: "suspended",
    color: "orange",
    icon: "fa fa-pause-circle",
    description: "accountSuspended",
  },
  [STATUS_DELETED]: {
    label: "inactive",
    color: "gray",
    icon: "fa fa-times-circle",
    description: "accountInactive",
  },
}

export const MAX_2FA_ATTEMPTS = 3

export type AgencyUser = z.infer<typeof AgencyUserSchema>
export type AgencyUserFormValues = z.infer<typeof AgencyUserFormSchema>
export type Integration = z.infer<typeof IntegrationSchema>
export type CopyableIntegration = z.infer<typeof CopyableIntegrationSchema>
export type ResetPasswordFormValues = z.infer<typeof ResetPasswordSchema>
